/*
 * @Descripttion : 
 * @version      : 
 * @Author       : min
 * @Date         : 2023-02-28 16:04:22
 * @LastEditors  : min
 * @LastEditTime : 2025-05-14 11:31:52
 */
/*
 * @Descripttion :
 * @version      :
 * @Author       : ml
 * @Date         : 2020-08-03 18:49:40
 * @LastEditors  : min
 * @LastEditTime : 2025-05-14 09:55:36
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)

const routes = [
	{
		path: '/lianmengpai',
		name: 'lianmengpai',
		component: () => import('../views/lianmengpai/index'),
		children: [
			{
				path: '/guesslike',
				name: 'guesslike',
				meta: {
					title: '猜你喜欢',
				},
				component: () => import('../views/lianmengpai/pushManage/pushGuessLike.vue'),
			},
			{
				path: '/marketAuction',
				name: 'marketAuction',
				meta: {
					title: '',
				},
				component: () => import('../views/lianmengpai/pushManage/marketAuctionList.vue'),
			},
			{
				path: '/transfer',
				name: 'transfer',
				meta: {
					title: '过户办理',
				},
				component: () => import('../views/lianmengpai/transferManage/transferHandle.vue'),
			},
			{
				path: '/propagand',
				name: 'propagand',
				meta: {
					title: '车赢办证',
				},
				component: () => import('../views/lianmengpai/activity/conductPropaganda.vue'),
			},
			{
				path: '/anniversary',
				name: 'anniversary',
				meta: {
					title: '周年庆典',
				},
				component: () => import('../views/lianmengpai/activity/anniversaryCelebration.vue'),
			},
			{
				path: '/anniversarycarlist',
				name: 'anniversarycarlist',
				meta: {
					title: '928六周年庆专场',
				},
				component: () => import('../views/lianmengpai/activity/anniversaryCarList.vue'),
			},
			{
				path: '/manners',
				name: 'manners',
				meta: {
					title: 'VIP会员特权',
				},
				component: () => import('../views/lianmengpai/activity/anniversaryManners.vue'),
			},
			{
				path: '/carwinsgift',
				name: 'carwinsgift',
				meta: {
					title: '联盟拍豪赠六百万',
				},
				component: () => import('../views/lianmengpai/activity/anniversaryGift.vue'),
			},
			{
				path: '/carwinslogistics',
				name: 'carwinslogistics',
				meta: {
					title: '车赢代驾与物流',
				},
				component: () => import('../views/lianmengpai/activity/anniversaryLogistics.vue'),
			},
			{
				path: '/platformRules',
				name: 'platformRules',
				meta: {
					title: '平台规则',
				},
				component: () => import('../views/lianmengpai/platformRules/platformRules.vue'),
			},
			{
				path: '/serviceAgreement',
				name: 'serviceAgreement',
				meta: {
					title: '平台服务协议',
				},
				component: () => import('../views/lianmengpai/platformRules/serviceAgreement.vue'),
			},
			{
				path: '/privacyAgreement',
				name: 'privacyAgreement',
				meta: {
					title: '平台隐私协议',
				},
				component: () => import('../views/lianmengpai/platformRules/privacyAgreement.vue'),
			},
			{
				path: '/privacyAgreementGh',
				name: 'privacyAgreementGh',
				meta: {
					title: '平台隐私协议',
				},
				component: () => import('../views/lianmengpai/platformRules/privacyAgreementGh.vue'),
			},
			{
				path: '/auctionAgreement',
				name: 'auctionAgreement',
				meta: {
					title: '',
				},
				component: () => import('../views/lianmengpai/platformRules/auctionAgreement.vue'),
			},
			{
				path: '/businessRule',
				name: 'businessRule',
				meta: {
					title: '联盟拍业务规则',
				},
				component: () => import('../views/lianmengpai/platformRules/businessRule.vue'),
			},
			{
				path: '/logistics',
				name: 'logistics',
				meta: {
					title: '物流询价',
				},
				component: () => import('../views/lianmengpai/logistics/logisticsSearch.vue'),
			},
			{
				path: '/bindminipragram',
				name: 'bindminipragram',
				meta: {
					title: '绑定小程序',
				},
				component: () => import('../views/lianmengpai/miniprogram/bindMiniProgram.vue'),
			},
			{
				path: '/biddingExplain',
				name: 'biddingExplain',
				meta: {
					title: '竞价说明',
				},
				component: () => import('../views/lianmengpai/biddingExplain/biddingExplain.vue'),
			},
			{
				path: '/collectCoupons',
				name: 'collectCoupons',
				meta: {
					title: '领取优惠券',
				},
				component: () => import('../views/lianmengpai/activity/collectCoupons.vue'),
			},
			{
				path: '/activeinteragency',
				name: 'activeinteragency',
				meta: {
					title: '领取优惠券',
				},
				component: () => import('../views/lianmengpai/activity/interAgencyCar.vue'),
			},
			{
				path: '/offlineshooting',
				name: 'offlineshooting',
				meta: {
					title: '线下拍上线啦',
				},
				component: () => import('../views/lianmengpai/activity/offlineShooting'),
			},
			{
				path: '/activecarfestivalindex',
				name: 'activecarfestivalindex',
				meta: {
					title: '928拍车节',
				},
				component: () => import('../views/lianmengpai/activity/activity2021928_index.vue'),
			},
			{
				path: '/activecarfestival',
				name: 'activecarfestival',
				meta: {
					title: '928拍车节',
				},
				component: () => import('../views/lianmengpai/activity/activity2021928.vue'),
			},
			{
				path: '/activity',
				name: 'activity',
				meta: {
					title: '928拍车节',
				},
				component: () => import('../views/lianmengpai/activity/activity2021928foreign.vue'),
			},
			{
				path: '/activity928',
				name: 'activity928',
				meta: {
					title: '928拍车节',
				},
				component: () => import('../views/lianmengpai/activity/activity2021928foreign.vue'),
			},
			{
				path: '/carwinsactivity',
				name: 'carwinsactivity',
				meta: {
					title: '928拍车节',
				},
				component: () => import('../views/lianmengpai/activity/activity2021928foreign.vue'),
			},
			{
				path: '/activecollectcoupons',
				name: 'activecollectcoupons',
				meta: {
					title: '快卖车领券',
				},
				component: () => import('../views/lianmengpai/activity/activityCollectCoupons.vue'),
			},
			{
				path: '/activitykmcdetail',
				name: 'activitykmcdetail',
				meta: {
					title: '快卖车活动详情',
				},
				component: () => import('../views/lianmengpai/activity/activityKmcDetail.vue'),
			},
			{
				path: '/dealConfirmGetDetail',
				name: 'dealConfirmGetDetail',
				meta: {
					title: '成交信息确认',
				},
				component: () => import('../views/lianmengpai/dealManage/dealConfirmGetDetail.vue'),
			},
			{
				path: '/sessionExplain',
				name: 'sessionExplain',
				meta: {
					title: '场次说明',
				},
				component: () => import('../views/lianmengpai/platformRules/sessionExplain.vue'),
			},
			{
				path: '/auctionInspect',
				name: 'auctionInspect',
				meta: {
					title: '拍卖观摩',
				},
				component: () => import('../views/lianmengpai/auctionInspectManage/auctionInspect.vue'),
			},
			{
				path: '/auctionInspectDet',
				name: 'auctionInspectDet',
				meta: {
					title: '车辆详情',
				},
				component: () => import('../views/lianmengpai/auctionInspectManage/auctionInspectDet.vue'),
			},
			{
				path: '/auctionInspectPublic',
				name: 'auctionInspectPublic',
				meta: {
					title: '拍卖观摩公用页面',
				},
				component: () => import('../views/lianmengpai/auctionInspectManage/auctionInspectPublic.vue'),
			},
			{
				path: '/annualStatem2021',
				name: 'annualStatem2021',
				meta: {
					title: '年度账单',
				},
				component: () => import('../views/lianmengpai/annualStatem/annualStatem2021.vue'),
			},
			{
				path: '/qmy',
				name: 'qmy',
				meta: {
					title: '漆膜仪',
				},
				component: () => import('../views/lianmengpai/marketBanner/marketBannerQMY.vue'),
			},
			{
				path: '/HolidayNotice2022',
				name: 'HolidayNotice2022',
				meta: {
					title: '春节运营公告',
				},
				component: () => import('../views/lianmengpai/marketBanner/HolidayNotice2022.vue'),
			},
			{
				path: '/boche',
				name: 'boche',
				meta: {
					title: '联盟拍帮卖车',
				},
				component: () => import('../views/lianmengpai/marketBanner/marketBannerBoChe.vue'),
			},
			{
				path: '/dealArbitrate',
				name: 'dealArbitrate',
				meta: {
					title: '仲裁单',
				},
				component: () => import('../views/lianmengpai/arbitrate/dealArbitrateDetail.vue'),
			},
			{
				path: '/chexin',
				name: 'chexin',
				meta: {
					title: '出险报告使用提示',
				},
				component: () => import('../views/lianmengpai/marketBanner/marketBannerCheXin.vue'),
			},
			{
				path: '/chexinreport',
				name: 'chexinreport',
				meta: {
					title: '车况报告',
				},
				component: () => import('../views/lianmengpai/marketBanner/cheXinReport.vue'),
			},
			{
				path: '/privacyAgreementPengLong',
				name: 'privacyAgreementPengLong',
				meta: {
					title: '平台隐私协议',
				},
				component: () => import('../views/lianmengpai/platformRules/privacyAgreementCommon.vue'),
			},
			{
				path: '/privacyAgreementFCB',
				name: 'privacyAgreementFCB',
				meta: {
					title: '平台隐私协议',
				},
				component: () => import('../views/lianmengpai/platformRules/privacyAgreementCommon.vue'),
			},
			{
				path: '/privacyAgreementJCXT',
				name: 'privacyAgreementJCXT',
				meta: {
					title: '平台隐私协议',
				},
				component: () => import('../views/lianmengpai/platformRules/privacyAgreementCommon.vue'),
			},
			{
				path: '/privacydcyc',
				name: 'privacydcyc',
				meta: {
					title: '平台隐私协议',
				},
				component: () => import('../views/lianmengpai/platformRules/privacyAgreementCommon.vue'),
			},
			{
				path: '/privacyhcy',
				name: 'privacyhcy',
				meta: {
					title: '平台隐私协议',
				},
				component: () => import('../views/lianmengpai/platformRules/privacyAgreementCommon.vue'),
			},
			{
				path: '/serviceQuality',
				name: 'serviceQuality',
				meta: {
					title: '服务评价',
				},
				component: () => import('../views/lianmengpai/serviceQuality/serviceQuality.vue'),
			},
			{
				path: '/reportCheXin',
				name: 'reportCheXin',
				meta: {
					title: '出险报告查询',
				},
				component: () => import('../views/lianmengpai/reportManage/reportCheXin.vue'),
			},
			{
				path: '/reportNoCheck',
				name: 'reportNoCheck',
				meta: {
					title: '检测报告',
				},
				component: () => import('../views/lianmengpai/reportManage/reportNoCheck.vue'),
			},
			{
				path: '/network',
				name: 'network',
				meta: {
					title: '网络检测',
				},
				component: () => import('../views/lianmengpai/network/network.vue'),
			},
			{
				path: '/marketLive',
				name: 'marketLive',
				meta: {
					title: '928直播月',
				},
				component: () => import('../views/lianmengpai/marketBanner/marketLive928.vue'),
			},
			{
				path: '/activity2022928',
				name: 'activity2022928',
				meta: {
					title: '928拍车节',
				},
				component: () => import('../views/lianmengpai/activity/activity2022928.vue'),
			},
			{
				path: '/activity2022928Ceremony',
				name: 'activity2022928Ceremony',
				meta: {
					title: '928拍车节典礼',
				},
				component: () => import('../views/lianmengpai/activity/activity2022928Ceremony.vue'),
			},
			{
				path: '/issue',
				name: 'issue',
				meta: {
					title: '拍卖模式说明',
				},
				component: () => import('../views/lianmengpai/issueManage/issuedetails.vue'),
			},
			{
				path: '/chexinfree',
				name: 'chexinfree',
				meta: {
					title: '车信出险免费查',
				},
				component: () => import('../views/lianmengpai/chexin/freeInquiry.vue'),
			},
			{
				path: '/live1205',
				name: 'live1205',
				meta: {
					title: '直播拍车',
				},
				component: () => import('../views/lianmengpai/live/liveActivity1205.vue'),
			},
			{
				path: '/reportczj',
				name: 'reportczj',
				meta: {
					title: '车智检上线',
				},
				component: () => import('../views/lianmengpai/marketBanner/reportCZJ.vue'),
			},
			{
				path: '/myWallet',
				name: 'myWallet',
				meta: {
					title: '我的钱包',
				},
				component: () => import('../views/lianmengpai/myWallet/myWallet.vue'),
			},
			{
				path: '/myInvoice',
				name: 'myInvoice',
				meta: {
					title: '我的发票',
				},
				component: () => import('../views/lianmengpai/dealerInvoiceManage/invoiceList.vue'),
			},
			{
				path: '/invoiceSelect',
				name: 'invoiceSelect',
				meta: {
					title: '选择开票订单',
				},
				component: () => import('../views/lianmengpai/dealerInvoiceManage/invoiceSelect.vue'),
			},
			{
				path: '/invoiceCreate',
				name: 'invoiceCreate',
				meta: {
					title: '选择开票订单',
				},
				component: () => import('../views/lianmengpai/dealerInvoiceManage/invoiceCreate.vue'),
			},
			{
				path: '/invoiceDetail',
				name: 'invoiceDetail',
				meta: {
					title: '开票详情',
				},
				component: () => import('../views/lianmengpai/dealerInvoiceManage/invoiceDetail.vue'),
			},
			{
				path: '/instroductionWarranty',
				name: 'instroductionWarranty',
				meta: {
					title: '延保简介',
				},
				component: () => import('../views/lianmengpai/extendedWarranty/instroductionWarranty.vue'),
			},
			{
				path: '/termWarranty',
				name: 'termWarranty',
				meta: {
					title: '车况无忧险保障条款',
				},
				component: () => import('../views/lianmengpai/extendedWarranty/termWarranty.vue'),
			},
		]
	},
	{
		path: '/guanghui',
		name: 'guanghui',
		component: () => import('../views/guanghui/index'),
		children: [
			{
				path: '/guanghui/binddingnotice',
				name: 'binddingnotice',
				meta: {
					title: '广汇场次排期',
				},
				component: () => import('../views/guanghui/biddingNotice.vue'),
			}
		]
	},
	{
		path: '/plreport',
		name: 'plreport',
		meta: {
			title: '检测报告',
		},
		component: () => import('../views/penglongpai/report.vue'),
	},
]

const router = new VueRouter({
	routes,
})

export default router
